import Colors from "./colors";

export function setCssVariables() {
  const root = document.documentElement;

  //app
  root.style.setProperty("--app-secondaryBg", Colors.app.secondaryBg);
  // root.style.setProperty("--app-textLight", Colors.app.textLight);
  root.style.setProperty("--app-primaryBg", Colors.app.primaryBg);
  root.style.setProperty("--app-primary", Colors.app.primary);
  root.style.setProperty("--app-darkPrimary",Colors.app.darkPrimary);

  // Background
   root.style.setProperty("--bg-lightBg", Colors.background.textAreaBg);
  root.style.setProperty("--bg-default", Colors.background.default);
  root.style.setProperty("--bg-form", Colors.background.form);
  root.style.setProperty("--bg-lightBg", Colors.background.lightBg);
  root.style.setProperty("--bg-file-upload", Colors.background.fileUpload);
  root.style.setProperty("--bg-file-noDataBg", Colors.background.noDataBg);
  root.style.setProperty("--bg-upload", Colors.background.upload);
  root.style.setProperty(
    "--bg-file-upload-inner",
    Colors.background.fileUploadInner
  );
  root.style.setProperty("--bg-detailBg", Colors.background.detailBg);
  root.style.setProperty(
    "--background-detailRightBg",
    Colors.background.detailRightBg
  );
  root.style.setProperty(
    "--background-detailLeftBg",
    Colors.background.detailLeftBg
  );

  // Text
  root.style.setProperty("--text-primary", Colors.text.primary);
  root.style.setProperty("--text-secondary", Colors.text.secondary);
  root.style.setProperty("--text-accent", Colors.text.accent);
  root.style.setProperty("--text-dark", Colors.text.dark);
  root.style.setProperty("--text-para", Colors.text.para);
  root.style.setProperty("--text-noResult", Colors.text.noResult);
  root.style.setProperty("--text-noDataText", Colors.text.noDataText);
  root.style.setProperty("--text-library-items", Colors.text.libraryItems);
  root.style.setProperty("--text-PlaceHolderText", Colors.text.PlaceHolderText);
  root.style.setProperty("--text-input", Colors.text.inputText);
  root.style.setProperty("--text-loaderText", Colors.text.loaderText);
  root.style.setProperty(
    "--text-secondaryParaText",
    Colors.text.secondaryParaText
  );
  root.style.setProperty("--text-loginText", Colors.text.loginText);
  root.style.setProperty("--text-castTag", Colors.text.castTag);
  root.style.setProperty("--text-castRole", Colors.text.castRole);

  // Button
  root.style.setProperty("--button-dark", Colors.button.dark);
  root.style.setProperty("--button-secondary", Colors.button.secondary);
  root.style.setProperty("--button-text", Colors.button.text);
  root.style.setProperty("--button-hover", Colors.button.buttonhover);
  root.style.setProperty("--button-loader", Colors.button.buttonLoader);
  root.style.setProperty("--button-bg", Colors.button.buttonBg);
  root.style.setProperty("--button-new",Colors.button.newBtn)
  //input
  root.style.setProperty("--input-inputText", Colors.input.inputText);
  root.style.setProperty("--input-lightBg", Colors.input.lightBg);
  root.style.setProperty("--input-default", Colors.input.default);
  root.style.setProperty("--input-detailePage", Colors.input.detailePage);
  root.style.setProperty(
    "--input-pillCategoriesText",
    Colors.input.pillCategoriesText
  );
  root.style.setProperty(
    "--input-varientLightText",
    Colors.input.varientLightText
  );
  root.style.setProperty("--input-inputBg", Colors.input.inputBg);
  root.style.setProperty("--input-mediaURl", Colors.input.mediaURl);
  root.style.setProperty(
    "--input-PlaceHolderText",
    Colors.input.PlaceHolderText
  );
  //skeleton
  root.style.setProperty("--skeleton-background", Colors.skeleton.background);
  root.style.setProperty("--skeleton-btnBg", Colors.skeleton.btnBg);
  root.style.setProperty("--skeleton-btnText", Colors.skeleton.btnText);
  root.style.setProperty("--skeleton-saveDraft", Colors.skeleton.saveDraft);
  //progressBar
  root.style.setProperty("--progressBar-background", Colors.progressBar.background);
  root.style.setProperty("--progressBar-progressColor", Colors.progressBar.progressColor);
  root.style.setProperty("--progressBar-textColor", Colors.progressBar.textColor);
  //status
  root.style.setProperty("--status-queued", Colors.status.queued);
  root.style.setProperty("--status-processing", Colors.status.processing);
  root.style.setProperty("--status-completed", Colors.status.completed);
  root.style.setProperty("--status-failed", Colors.status.failed);
  //chips
  root.style.setProperty("--chips-movie", Colors.chips.Movie);
  root.style.setProperty("--chips-series", Colors.chips.Series);
  root.style.setProperty("--chips-podcast", Colors.chips.Podcast);
  root.style.setProperty("--chips-live-Channel", Colors.chips["Live Channel"]);
  root.style.setProperty("--chips-live-stream", Colors.chips["Live Stream"]);
  root.style.setProperty("--chips-short-chip", Colors.chips["Short Clip"]);
  root.style.setProperty("--chips-text", Colors.chips.text);
  //QC_Status
  root.style.setProperty("--qc-approved", Colors.QC_Status.Approved);
  root.style.setProperty("--qc-rejected", Colors.QC_Status.Rejected);
  root.style.setProperty("--qc-pending", Colors.QC_Status.Pending);
  //status
  root.style.setProperty("--status-approved", Colors.status.Approved);
  root.style.setProperty("--status-rejected", Colors.status.Rejected);
  root.style.setProperty("--status-NA", Colors.status["N/A"]);
  root.style.setProperty(
    "--status-pending-review",
    Colors.status["Pending Review"]
  );
  root.style.setProperty("--status-save-draft", Colors.status["Save Draft"]);

  //table
  root.style.setProperty("--table-primary", Colors.table.primary);
  // modal
  root.style.setProperty("--modal-overlayBg", Colors.modal.overlayBg);
  root.style.setProperty("--modal-modalBg", Colors.modal.modalBg);
  root.style.setProperty(
    "--modal-pillCategorieModalBg",
    Colors.modal.pillCategorieModalBg
  );
  // Border
  root.style.setProperty("--border-color", Colors.border.color);
    root.style.setProperty("--border-transparent", Colors.border.transparent);
  root.style.setProperty("--border-dark", Colors.border.dark);
  root.style.setProperty("--border-light", Colors.border.light);
   root.style.setProperty("--border-edit", Colors.border.edit);
  root.style.setProperty(
    "--border-newButtonBorder",
    Colors.border.newButtonBorder
  );
  root.style.setProperty("--border-noDataBorder", Colors.border.noDataBorder);
  //search
  root.style.setProperty("--search-dropdown", Colors.search.dropdownHover);
  root.style.setProperty("--search-dropdownBg", Colors.search.dropdownBg);
  root.style.setProperty("--search-border", Colors.search.border);
  //active
  root.style.setProperty("--active-color", Colors.active.color);
  //tab
  root.style.setProperty("--tab-color", Colors.tab.color)
  root.style.setProperty("--tab-activeBg", Colors.tab.activeBg);
  root.style.setProperty("--tab-innerBoxBg", Colors.tab.innerBoxBg);
  root.style.setProperty("--tab-innerBoxText", Colors.tab.innerBoxText);

  
  //loader
  root.style.setProperty("--loader-color", Colors.loader.color);
  root.style.setProperty("--loader-dark", Colors.loader.dark);
  root.style.setProperty("--loader-background", Colors.loader.background);
  root.style.setProperty("--loader-border", Colors.loader.loaderBorder);

  // Icon
  root.style.setProperty("--icon-dark", Colors.icon.dark);
  root.style.setProperty("--icon-light", Colors.icon.light);
  root.style.setProperty("--icon-noData", Colors.icon.noData);
  root.style.setProperty("--icon-user", Colors.icon.user);
  root.style.setProperty("--icon-pillSearchIcon", Colors.icon.pillSearchIcon);
  root.style.setProperty("--icon-user-iconBg", Colors.icon.userIconBg);
  root.style.setProperty("--icon-box-shadow", Colors.icon.boxShadow);
    root.style.setProperty("--icon-cameraIconBg", Colors.icon.cameraIconBg);

  // toast

  root.style.setProperty("--toast-success", Colors.toast.success);
  root.style.setProperty("--toast-error", Colors.toast.error);
  root.style.setProperty("--toast-warning", Colors.toast.warning);
  root.style.setProperty("--toast-warningColor", Colors.toast.warningColor);
  root.style.setProperty("--toast-info", Colors.toast.info);

  // ───────────────────────────────────────────────────────────────────────
  // Design-system scales (Phase 0). Emitted generically so adding a token to
  // colors.js automatically exposes a matching CSS variable — no need to add a
  // setProperty line per token. Naming: --<group>-<key>, e.g. --surface-raised,
  // --accent-base, --space-lg, --radius-lg, --fs-stat, --state-success.
  // ───────────────────────────────────────────────────────────────────────
  const emitGroup = (prefix, group) => {
    if (!group) return;
    Object.entries(group).forEach(([key, value]) => {
      if (value == null) return;
      root.style.setProperty(`--${prefix}-${key}`, value);
    });
  };

  emitGroup("surface", Colors.surface);
  emitGroup("accent", Colors.accent);
  emitGroup("fg", Colors.fg);
  emitGroup("space", Colors.spacing);
  emitGroup("radius", Colors.radius);
  emitGroup("fs", Colors.fontSize);
  emitGroup("state", Colors.state);
}
